exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-dialog > .v-card > .v-toolbar {\n    position: sticky;\n    top: 0;\n    z-index: 999;\n}\n\n", ""]);

// exports
